class Routes{
    static login = "/login";
}
export default Routes